import React, { useState, useEffect } from 'react';
import { CCol, CRow, CInput, CTabs, CTabContent, CTabPane, CNav, CNavItem, CNavLink, CDropdown, CDropdownItem, CDropdownToggle, CDropdownMenu, CTooltip } from '@coreui/react';

import 'react-circular-progressbar/dist/styles.css';
import './ProjectDetails.css';
import { useHistory } from 'react-router-dom';
import { TabPane } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { showError } from 'src/utils/swalError';
import ProjectOverview from './ProjectOverview';
import ProjectTask from './ProjectTask';
import ProjectBudgetCost from './ProjectBudgetCost';
import ProjectBudgetDetail from './ProjectBudgetDetail';
import Materials from './Materials';
import Equipment from './Equipment';
import Team from './Team';
import $axios from 'src/utils/axios';
import { OverviewWarning } from 'src/request/OverView';
import Updates from './Updates';
import Report from './Report';
import { FaPencilAlt, FaCheck, FaArrowCircleLeft, FaExclamationCircle } from 'react-icons/fa';
import { GetProjectTabStatus, GetTabWarnings } from 'src/request/Projects';
import { setModule } from 'src/store/feature/module/moduleSlice';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';


const ProjectDetails = (props) => {

  const history = useHistory();
  const Swal = require('sweetalert2');
  let user_id = parseInt(localStorage.getItem('user_id'));
  const [active, setActive] = useState(1);
  const [dropdownvalue, setDroupDownValue] = useState('Detail');
  const [projectId, setprojectId] = useState('');
  const dispatch = useDispatch();
  const [disabled, setdisabled] = useState(false);
  const [requireDisable, setRequireDisabled] = useState(false);
  const [projectName, setProjectName] = useState('');
  const [editProjectName, setEditProjectName] = useState(false);
  const [identifier, setIdentefier] = useState('');
  const [tabStatus, setTabStatus] = useState({});
  const { search } = useLocation();
  const values = queryString.parse(search);
  const [requireDisablePSOW, setRequireDisabledPSOW] = useState(false);
  const [reportActiveTab, setReportActiveTab] = useState(1);
  const [missedDates, setMissedDates] = useState([]);
  const [reportHasWarning, setReportHasWarning] = useState(false);
  const [OverviewHasWarning, setOverviewHasWarning] = useState(false);
  const [historicalReportCount, setHistoricalReportCount] = useState(0);
  const [estimateStatus, setEstimateStatus] = useState(null);

  const location = useLocation();
  let { project_id, type, start, end, identifiers } = location.state || {};

  const idToUse = props.ProjectId !== undefined ? props.ProjectId : project_id;

  const menu = !isNaN(values?.menu) ? parseInt(values?.menu) : null;
  const sowId = !isNaN(values?.sowId) ? parseInt(values?.sowId) : null;
  const phaseId = !isNaN(values?.phaseId) ? parseInt(values?.phaseId) : null;
  useEffect(() => {
    const fetchData = async () => {
      await getdetailed(idToUse);
      await getoverview(idToUse);
      await getProjectTabStatus(idToUse);
      await getTabWarnings(idToUse);
    };
    if (props.ProjectId !== undefined) {
      setIdentefier(props.Identifier);
    }

    setprojectId(idToUse);
    fetchData();

    if (menu > 0 && menu < 9) {
      if (menu === 3) {
        setDroupDownValue('SOW');
      }
      switch (menu) {
        case 1:
          dispatch(setModule('project-overview'))
          break;
        case 2:
          setActive(2);
          dispatch(setModule('project-estimate'))
          break;
        case 3:
          setActive(3);
          dispatch(setModule('project-scope-of-work'))
          break;
        case 4:
          setActive(4);
          dispatch(setModule('project-materials'))
          break;
        case 5:
          dispatch(setModule('project-equipment'))
          break;
        case 6:
          setActive(6);
          dispatch(setModule('project-team'))
          break;
        case 7:
          dispatch(setModule('project-reports'))
          break;
        case 8:
          setActive(8);
          dispatch(setModule('project-updates'))
          break;
        default:
          dispatch(setModule('project-overview'))
          break;
      }
    }
  }, [props]);

  const getTabWarnings = (projectId) => {
    GetTabWarnings(projectId).then(({ data }) => {
      if (data.status === 200) {
        setReportHasWarning(data.response.Report.warning);
        setHistoricalReportCount(data.response.Report.count.historical_report);
      }
    });
    OverviewWarning(projectId).then((res) => {
      if (res.data.status === 200) {
        setOverviewHasWarning(res?.data?.results[0]?.warning);
      }
    });
  };

  const getProjectTabStatus = (projectId) => {
    GetProjectTabStatus(projectId).then(({ data }) => {
      if (data.status === 200) {
        setTabStatus(data.response);
      }
    });
  };

  const save = (project_id) => {
    let data = {
      name: projectName,
      identifier: identifier,
      user_id: user_id,
    };

    const company_id = parseInt(localStorage.getItem('company_id'));
    $axios
      .put(`overview/${company_id}/${project_id}`, {
        update: data,
      })
      .then((res) => {
        if (res.data.status === 1) {
          getoverview(project_id);
          setEditProjectName(!editProjectName);
          Swal.fire({
            icon: 'success',
            title: 'Your work has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
        }
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
      });
  };

  const getoverview = (project_id) => {
    const company_id = parseInt(localStorage.getItem('company_id'));
    $axios
      .get(`overview/${company_id}/${project_id}`)
      .then((res) => {
        if (res.data.status === 1) {
          setProjectName(res.data.response.project_info.name);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
      });
  };

  const getdetailed = (project_id) => {
    const company_id = parseInt(localStorage.getItem('company_id'));
    $axios
      .get(`estimate/${company_id}/${project_id}`)
      .then((res) => {
        if (res?.data?.status === 200) setEstimateStatus(res?.data?.response?.estimate_status);
        if (res.data.response.detailed.length === 1) {
          setdisabled(true);
          setDroupDownValue('Detail');
        }
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
      });
  };

  const disableEstimate = (val) => {
    setRequireDisabled(val);
  };

  const disablePSOW = (val) => {
    setRequireDisabledPSOW(val);
  };

  const back = () => {
    history.push({
      pathname: '/projects/Index',
    });
    window.location.reload(true);
  };

  return (
    <>
      <CRow>
        <FaArrowCircleLeft
          className="back_button"
          onClick={back}
        />
        <CCol xm="12" sm="12" md="8" lg="8" xl="8">
          {editProjectName === true ? (
            <CCol lg="9" xl="9">
              <CRow>
                <CCol lg="10" xl="10" style={{ padding: '0px' }}>
                  <CInput value={projectName} onChange={(e) => setProjectName(e.target.value)} />
                </CCol>
                <CCol lg="2" xl="2">
                  <FaCheck style={{ width: '20px', height: '20px', color: '#3A7D21' }} onClick={() => save(props.ProjectId)} />
                </CCol>
                <CCol lg="5" xl="5" style={{ padding: '0px', marginTop: '10px' }}>
                  <CInput value={identifier} onChange={(e) => setIdentefier(e.target.value)} />
                </CCol>
              </CRow>
            </CCol>
          ) : (
            <span className="Title">
              {projectName}{' '}
              <span>
                {active === 1 && (
                  <FaPencilAlt
                    style={{
                      marginLeft: '10px',
                      width: '20px',
                      height: '20px',
                    }}
                    onClick={() => setEditProjectName(!editProjectName)}
                  />
                )}
              </span>
              <div>
                <span>Project ID : {identifier}</span>
              </div>
            </span>
          )}

          <div>
            <span className="Description"></span>
          </div>
        </CCol>
        <CCol xm="12" sm="12" md="12" lg="12" style={{ marginTop: '20px' }}>
          <CTabs activeTab={active - 1}>
            <CNav variant="tabs">
              <CNavItem>
                <CNavLink
                  size="sm"
                  className={`projecttabs${!tabStatus?.overview ? '-desabled' : active === 1 ? '-active' : ''} border-tabs-radios`}
                  onClick={() => {
                    setActive(1);
                    dispatch(setModule('project-overview'))
                  }}
                  style={{ position: 'relative' }}
                >
                  Overview
                  {OverviewHasWarning && (
                    <CTooltip content="Some POW amounts are missing. Please input the missing POW amounts">
                      <FaExclamationCircle
                        style={{
                          position: 'absolute',
                          top: '-10px',
                          right: '-3px',
                          padding: '0',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '24px',
                          height: '24px',
                          color: '#B42A19',
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          animation: 'pulse 2s infinite',
                        }}
                      />
                    </CTooltip>
                  )}
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink
                  className={`projecttabs${!tabStatus?.estimate ? '-desabled' : active === 2 ? '-active' : ''} border-tabs-radios`}
                  disabled={!tabStatus?.estimate}
                  style={{ fontSize: '12px' }}
                  onClick={() => {
                    setActive(2);
                    setDroupDownValue('Detail');
                    dispatch(setModule('project-estimate'))
                  }}
                >
                  Estimate
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink
                  className={`projecttabs${!tabStatus?.scope_of_work ? '-desabled' : active === 3 ? '-active' : ''} border-tabs-radios`}
                  disabled={!tabStatus?.scope_of_work}
                  onClick={() => {
                    setActive(3);
                    setDroupDownValue('SOW');
                    dispatch(setModule('project-scope-of-work'));
                  }}
                  style={{ fontSize: '12px' }}
                >
                  Scope of Work
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink
                  className={`projecttabs${!tabStatus?.report ? '-desabled' : active === 7 ? '-active' : ''} border-tabs-radios`}
                  disabled={!tabStatus?.report}
                  onClick={() => {
                    setActive(7);
                    dispatch(setModule('project-reports'))
                  }}
                  style={{ position: 'relative' }}
                >
                  {reportHasWarning && (
                    <CTooltip content={`There are missing report. Please input the missing reports`} placement="right-end" color="white">
                      <FaExclamationCircle
                        style={{
                          position: 'absolute',
                          top: '-10px',
                          right: '-3px',
                          padding: '0',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '24px',
                          height: '24px',
                          color: '#B42A19',
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          animation: 'pulse 2s infinite',
                        }}
                      />
                    </CTooltip>
                  )}
                  Report
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink
                  className={`projecttabs${!tabStatus?.materials ? '-desabled' : active === 4 ? '-active' : ''} border-tabs-radios`}
                  disabled={!tabStatus?.materials}
                  onClick={() => {
                    setActive(4);
                    setDroupDownValue('SOW');
                    dispatch(setModule('project-materials'))
                  }}
                >
                  Materials
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink
                  className={`projecttabs${!tabStatus?.equipment ? '-desabled' : active === 5 ? '-active' : ''} border-tabs-radios`}
                  disabled={!tabStatus?.equipment}
                  onClick={() => {
                    setActive(5);
                    dispatch(setModule('project-equipment'))
                  }}
                >
                  Equipment
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink
                  className={`projecttabs${!tabStatus?.team ? '-desabled' : active === 6 ? '-active' : ''} border-tabs-radios`}
                  disabled={!tabStatus?.team}
                  onClick={() => {
                    setActive(6);
                    dispatch(setModule('project-team'))
                  }}
                >
                  Team
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink
                  className={`projecttabs${!tabStatus?.notes ? '-desabled' : active === 8 ? '-active' : ''} border-tabs-radios`}
                  disabled={!tabStatus?.notes}
                  onClick={() => {
                    setActive(8);
                    dispatch(setModule('project-updates'))
                  }}
                >
                  Updates
                </CNavLink>
              </CNavItem>

              {[2, 3].includes(active) ? (
                <CCol
                  xs="12"
                  md="6"
                  lg="6"
                  xl="1"
                  className="button-mobile-margin"
                >
                  <CRow className="float-right">
                    <CCol className="float-right" xs="6" sm="6" md="6" lg="6">
                    </CCol>
                    <CCol className="float-right" xs="5" sm="5" md="5" lg="5">
                      <CDropdown>
                        <CDropdownToggle
                          color="secondary_base"
                          size="sm"
                          block
                          className="button-size-budget"
                        >
                          {dropdownvalue} View
                        </CDropdownToggle>
                        <CDropdownMenu>
                          {active === 2 ? (
                            <>
                              <CDropdownItem onClick={() => setDroupDownValue('Summary')}>Summary</CDropdownItem>
                              <CDropdownItem onClick={() => setDroupDownValue('Detail')}>Detail</CDropdownItem>
                            </>
                          ) : (
                            <>
                              <CDropdownItem onClick={() => setDroupDownValue('SOW')}>Scope Of Work</CDropdownItem>
                            </>
                          )}
                          <CDropdownItem onClick={() => setDroupDownValue('Description')}>Work Item Description</CDropdownItem>
                        </CDropdownMenu>
                      </CDropdown>
                    </CCol>
                  </CRow>
                </CCol>
              ) : (
                ''
              )}
            </CNav>
            <CTabContent className="project-border" fade={false}>
              <CTabPane>{active === 1 && <ProjectOverview project_id={props.ProjectId} validate={disableEstimate} refreshTabStatus={getProjectTabStatus} getTabWarnings={getTabWarnings} estimateStatus={estimateStatus} />}</CTabPane>
              <CTabPane>
                {(dropdownvalue === 'Detail' || dropdownvalue === 'Description') && active === 2 && <ProjectBudgetDetail project_id={props.ProjectId} order_by={dropdownvalue} project_type_id={props.ProjectType} estimate_status={props.Status} refreshTabStatus={getProjectTabStatus} getTabWarnings={getTabWarnings} />}

                {dropdownvalue === 'Summary' && active === 2 && <ProjectBudgetCost project_id={props.ProjectId} />}
              </CTabPane>
              <CTabPane>
                {active === 3 && props?.ProjectId && <ProjectTask id={props?.ProjectId} type={props?.ProjectType} start={props?.Start} sowId={sowId} phaseId={phaseId} end={props?.End} validate={disablePSOW} refreshTabStatus={getProjectTabStatus} order_by={dropdownvalue} />}
                {active === 3 && !props?.ProjectId && <ProjectTask id={project_id} type={type} start={start} end={end} validate={disablePSOW} refreshTabStatus={getProjectTabStatus} order_by={dropdownvalue} />}
              </CTabPane>

              <CTabPane>{active === 4 && <Materials project_id={props.ProjectId} project_name={props.ProjectName} />}</CTabPane>
              <CTabPane>{active === 5 && <Equipment id={props.ProjectId} project_start={props.Start} project_end={props.End} project_name={props.ProjectName} />}</CTabPane>
              <CTabPane>{active === 6 && <Team id={props.ProjectId} />}</CTabPane>

              <TabPane>
                {active === 7 && <Report id={props.ProjectId} type={props.ProjectType} activeTab={reportActiveTab} historicalReportCount={historicalReportCount} getTabWarnings={getTabWarnings} />}
              </TabPane>
              <CTabPane>{active === 8 && <Updates id={props.ProjectId} />}</CTabPane>
            </CTabContent>
          </CTabs>
        </CCol>
      </CRow>
    </>
  );
};

export default ProjectDetails;
